import styled from 'styled-components';

export const Flex = styled.div`
  display: flex;
  ${({ direction }) => (direction ? `flex-direction: ${direction}` : null)};
  ${({ align }) => (align ? `align-items: ${align}` : null)};
  ${({ justify }) => (justify ? `justify-content: ${justify}` : null)};
  ${({ wrap }) => (wrap ? `flex-wrap: ${wrap}` : null)};
`;
